import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import "./adminHomepage.css";
import axios from "axios";
import { Box, TextField, Button,Container, Grid, Typography,Autocomplete, Chip,TablePagination, CircularProgress, MenuItem, AppBar, Toolbar, ListItemText} from "@mui/material";
import NMH_LOGO_White_RGB from '../Assets/NMH_LOGO_White_RGB.png';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import UserToolbar from "./UserToolbar";

const UserHomepageview = () => {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [loading, setLoading] = useState(false);
  // const [postingTypes, setPostingTypes] = useState([]);
  const [costs, setCosts] = useState([]);
  const [modes, setModes] = useState([]);
  const [selectedCost, setSelectedCost] = useState("");
  const [selectedMode, setSelectedMode] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedPostingTypes, setSelectedPostingTypes] = useState([]);
  const [ savedPostIds, setsavedPostIds] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [hostOrganisations, setHostOrganisations] = useState([]);
  const sortOptions = [
    // { label: "Recently Added", value: "recent" },
    { label: "New to Old", value: "newToOld" },
    { label: "Old to New", value: "oldToNew" },
    { label: "Closest Deadline", value: "closestDeadline" },

  ];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userName, setUsername] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState("jn");
  const [selectedDeadline, setSelectedDeadline] = useState("");
  const [deadlineoptions, setDeadlineOptions] = useState([]);
  const fetchFilters = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/filters`);
    setCategories(response.data.categories);
    // setPostingTypes(response.data.postingTypes);
    setCosts(response.data.cost);
    setModes(response.data.mode);
    setDeadlineOptions(response.data.applicationDeadline);

  } catch (error) {
    console.error("Error fetching filters:", error);
  }
};

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });

        const { user, username } = res.data;
        if ( user === 'User') {
          setUserType(user);
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);


  const logoutAll = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');
      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};

  const fetchPosts = async () => {
    try {
 
       const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });

        const { user, username } = res.data;
        if ( user === 'User') {
          setUserType(user);
          setUsername(username);
        }
      const savedPostsbyUser= await axios.post(`${API_BASE_URL}/api/savedPostsByUser`,{userName:username});
      setsavedPostIds(savedPostsbyUser.data.map(event => event.postId._id));
      const responseevents = await axios.get(`${API_BASE_URL}/api/allActiveeventsWithImage`);
      setEvents(responseevents.data.data);
      const rawEvents = responseevents.data.data;
      const organisations = [...new Set(rawEvents.map(event => event.hostOrganisation).filter(Boolean))];
      setHostOrganisations(organisations);

    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

    const paginatedRows = events.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

 const applyFilters = async () => {
  setLoading(true);
  try {
    const payload = {
      sortBy:sortBy,
      categories: selectedCategories,
      // postingTypes: selectedPostingTypes,
      cost: selectedCost,
      mode: selectedMode,
      hostOrganisation: searchValue.trim() || null,
      deadline :selectedDeadline,

    };

    const response = await axios.post(`${API_BASE_URL}/api/activeEventsFilter`, payload);
    setEvents(response.data);
  } catch (error) {
    console.error("Error fetching filtered data:", error);
  } finally {
    setLoading(false);
  }
};



  const clearSelection = () => {
    fetchPosts();
    setSelectedCategories([]);
    // setSelectedPostingTypes([]);
    setSelectedCost("");
    setSelectedMode("");
    setSortBy("")
    setSearchValue("");
  };

  const getUsernamefromCookie = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
        withCredentials: true,
      });
      if (response.data.username) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching login status:", error);
      navigate("/login");
    }
  };

  useEffect(() => {
    fetchFilters();
    fetchPosts();
    getUsernamefromCookie();
  }, []);

  const bookmarkEvent = async (postId) => {
  try {
    setsavedPostIds((prev) => [...prev, postId]);

    const payload = {
      emailId: userName,    
      postId: postId
    };
    await axios.post(`${API_BASE_URL}/api/likePostByUser`, payload);
    const savedPostsbyUser= await axios.post(`${API_BASE_URL}/api/savedPostsByUser`,{userName});
    setsavedPostIds(savedPostsbyUser.data.map(event => event.postId._id));  } 
    catch (error) {
    console.error("Error saving post:", error);
    setsavedPostIds((prev) => prev.filter((id) => id !== postId));
  }
};

  const unsave = async (postId) => {
  try {
    setsavedPostIds((prev) => prev.filter((id) => id !== postId));

    const payload = {
      userName,    
      postId: postId
    };
  await axios.delete(`${API_BASE_URL}/api/unsavePost`, {data: payload,  headers: { 'Content-Type': 'application/json' }
    });

     const savedPostsbyUser= await axios.post(`${API_BASE_URL}/api/savedPostsByUser`,{userName});
    setsavedPostIds(savedPostsbyUser.data.map(event => event.postId._id));  
  } catch (error) {
    console.error("Error unsaving post:", error);
    setsavedPostIds((prev) => [...prev, postId]);
  }
};

return (
<Box sx={{ width: "100%", padding: 0, margin: 0 }}>
{isLoggedIn && userName ? (
  <>
    {/* <UserToolbar /> */}
      <br/>
                     <Box
        sx={{
          pt: { xs: 1, md: 2 },  
          pb: { xs: 1, md: 2 },   
          fontFamily: "Roboto, sans-serif",
        }}
      >
          <Container maxWidth="xl">
            <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
              <Grid item xs={12} md={7}>
                
                <Box sx={{
                    position: "relative",
                    paddingTop: "56.25%",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                  }}
                >
                  <img src="NMH Opportunities.jpeg"
                    alt="NMH Opportunities"
                      style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  />
                {/* <iframe
                  src="https://player.vimeo.com/video/1112936070?badge=0&autopause=0&player_id=0&app_id=58479"
                  title="GMT20250812-150751_Clip_Joe Latimer's Clip 08_12_2025"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                ></iframe> */}
                  </Box>
            
              </Grid>

              <Grid item xs={12} md={5}>
                <Typography
                  component="h1"
                  sx={{
                    color: "#002f5e",
                    fontWeight: 700,
                    fontSize: { xs: 28, md: 38 }, 
                    lineHeight: 1.2,
                    mb: { xs: 2, md: 3 },
                  }}
                >
                  Opportunities Beyond Campus

                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "1rem", md: "1.05rem" }, 
                    lineHeight: 1.7,
                    color: "#424242",
                    maxWidth: 560,
                  }}
                >
                 What are your passions? What are you curious about? What have you studied at Northfield Mount Hermon that you’re excited to take further?<br/><br/>

              Whether you’re looking for something during the academic year or over a break, remote or in person, on our Opportunities Beyond Campus site, you’ll 
              find information about pre-college courses, scholarships, leadership programs, contests and competitions, community service opportunities, 
              and more, curated by the NMH College Counseling team.<br/><br/>

              Bookmark the page and visit often for newly posted opportunities. And if you’re looking for something but can't find it, or if you have 
              questions or feedback, email us at <a href="mailto:college_counseling@nmhschool.org">
                    college_counseling@nmhschool.org 
                  </a>.<br/>
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
    <div className="form-container-1">
      <Box sx={{ width: "100%", borderColor: "divider" }}>
        <Typography sx={{ textAlign: "center", fontWeight: "bold", mb: 1 }}>
          All Events
        </Typography>

        <Box sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}>
           <Autocomplete
                freeSolo
                options={hostOrganisations} 
                inputValue={searchValue}
                onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Host Organization"
                    variant="outlined"
                  />
                )}
                sx={{ width: 250 }}
              />
          <Autocomplete
            multiple
            id="Category"
            options={categories}
            value={selectedCategories}
            onChange={(event, newValue) => setSelectedCategories(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Tag" variant="outlined" />
            )}
            sx={{ width: 250 }}
          />
          {/* <Autocomplete
            multiple
            id="PostingType"
            options={postingTypes}
            value={selectedPostingTypes}
            onChange={(event, newValue) => setSelectedPostingTypes(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Posting Type" variant="outlined" />
            )}
            sx={{ width: 250 }}
          /> */}
          {/* <Autocomplete
            disablePortal
            id="Cost"
            options={costs}
            value={selectedCost || null}
            onChange={(event, newValue) => setSelectedCost(newValue || "")}
            renderInput={(params) => (
              <TextField {...params} label="Cost" variant="outlined" />
            )}
            sx={{ width: 250 }}
          /> */}
          <Autocomplete
            disablePortal
            id="Mode"
            options={modes}
            value={selectedMode || null}
            onChange={(event, newValue) => setSelectedMode(newValue || "")}
            renderInput={(params) => (
              <TextField {...params} label="Mode" variant="outlined" />
            )}
            sx={{ width: 250 }}
          />

                <Autocomplete
                disablePortal
                id="Deadline"
                options={deadlineoptions}
                value={selectedDeadline || null}
                onChange={(event, newValue) => setSelectedDeadline(newValue || "")}
                renderInput={(params) => (
                  <TextField {...params} label="Deadline" variant="outlined" />
                )}
                sx={{ width: 250 }}
              />          
          <Autocomplete
            disablePortal
            id="SortBy"
            options={sortOptions}
            getOptionLabel={(option) => option.label}
            value={sortOptions.find((opt) => opt.value === sortBy) || null}
            onChange={(event, newValue) => setSortBy(newValue ? newValue.value : "")}
            renderInput={(params) => (
              <TextField {...params} label="Sort By" variant="outlined" />
            )}
            sx={{ width: 250 }}
          />
        </Box>

        <Box sx={{
          padding: 4,
          display: "flex",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Button variant="contained" color="primary" onClick={applyFilters}>
            Apply Filters
          </Button>
          <Button variant="outlined" onClick={clearSelection}>
            Clear Selection
          </Button>
        </Box>

        {loading ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : (
          <Box>
            <div className="event-list-container">
              {paginatedRows.map((event, index) => (
                <div key={index} className="event-card-horizontal">
                  {/* {event.eventImage ? (
                    <img
                      src={event.eventImage}
                      alt={event.eventName}
                      className="event-thumbnail-homepage"
                    />
                  ) : (
                    <div className="event-thumbnail-homepage"></div>
                  )} */}
                  <div className="event-content">
                    {/* <Typography
                      variant="h6"
                      className="event-title"
                      onClick={() => navigate(`/event/${event._id}`)}
                    >
                      {event.eventName}
                    </Typography> */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {/*       <Typography
                                 variant="h6"
                                 className="event-title"
                                 onClick={() => navigate(`/event/${event._id}`)}
                               >
                                 {event.eventName}
                               </Typography> */}
                               <Typography variant="h6" className="event-title">
                                  <a
                                    href={`/Opportunities/event/${event._id}`}
                                    onClick={(e) => {
                                      e.preventDefault(); 
                                      navigate(`/event/${event._id}`); 
                                    }}
                                    style={{
                                      color: 'inherit',
                                      textDecoration: 'none',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    {event.eventName}
                                  </a>
                                </Typography>
                               <Typography
                                 variant="body2"
                                 className="event-description"
                                 sx={{ color: '#2e5cb8' }}
                               >
                                 {event.hostOrganisation}
                               </Typography>
                             </div> 
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="body2" className="event-datetime">
                              {/* Posted: {new Date(event.postStartDate).toLocaleDateString("en-US", {
                                month: "short",
                                day: "numeric",
                              })}{" "}  */}
                              {event.applicationDeadline &&
                                `Deadline: ${new Date(event.applicationDeadline).toLocaleDateString("en-US", {
                                  month: "short",
                                  day: "numeric",
                                })}`
                              }
                               </Typography>
                             <Typography variant="body2" className="event-datetime" >  {event.mode}  </Typography>
                             </div>                   
                    {/* <Typography variant="body2" className="event-datetime">
                      Posted Date : {new Date(event.postStartDate).toLocaleDateString("en-US", {
                        weekday: "short",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })} · {event.mode}
                    </Typography> */}
                    <div className="event-tags">
                      {event.categories?.map((type, i) => (
                        <Chip
                          key={i}
                          label={type}
                          className="posting-type-chip"
                          onClick={() => {
                            setSelectedCategories((prev) => {
                              if (prev.includes(type)) return prev;
                              return [...prev, type];
                            });
                            applyFilters();
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      ))}
                    </div>
                    <Typography variant="body2" className="event-description">
                      {event.description.length > 200
                        ? `${event.description.substring(0, 200)}...`
                        : event.description}
                    </Typography>
                    <Typography
                      variant="body2"
                      className="event-read-more"
                      onClick={() => navigate(`/event/${event._id}`)}
                    >
                      Find out more »
                    </Typography>
                    <Typography variant="body2" className="event-read-more">
                      {savedPostIds.includes(event._id) ? (
                        <BookmarkIcon onClick={() => unsave(event._id)}  />
                      ) : (
                        <BookmarkBorderIcon onClick={() => bookmarkEvent(event._id)} />
                      )}
                    </Typography>
                  </div>
                </div>
              ))}
                <TablePagination
                          rowsPerPageOptions={[10, 20, 30]}
                          component="div"
                          count={events.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={(event, newPage) => setPage(newPage)}
                          onRowsPerPageChange={(event) => setRowsPerPage(parseInt(event.target.value, 10))}
                />              
            </div>
          </Box>
        )}
      </Box>
    </div>
  </>
) : (
  <h4>Checking authentication...</h4>
)}
</Box>
);

};

export default UserHomepageview;